module.exports = __webpack_public_path__ + "static/media/create-site-and-agent-step-1-br.ed92b706.png";